import { autoinject, customElement } from 'aurelia-framework';
import { PhotoSliderBaseCustomElement } from 'General/Resources/Elements/PhotoSlider/PhotoSliderBase';

@autoinject
@customElement('photo-slider')
export class PhotoSliderCustomElement extends PhotoSliderBaseCustomElement { }